import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

// Polyfills for IE11/Capybara. Required for StimulusJS.
import "element-closest"

const application = Application.start()
const context = require.context("../controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
